export const subscriptionExportableFields = [
  "all",
  "user_name",
  "user_mobile",
  "user_email",
  "gym_name",
  "plan_name",
  "type",
  "price",
  "trx_id",
  "payment_location",
  "subscription_status",
  "start_date",
  "expire_date",
  "subscription_added",
  "source_name",
  "checkout_source",
  "gender",
  "experience_level",
  "is_couple",
  "pause_status",
];
